// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__r-D-_","unreadBadge":"styles_unreadBadge__2922Y","modalContent":"styles_modalContent__3qWSS","modal":"styles_modal__6_LAG"};